import { Injectable } from '@angular/core';
import { CvApiServiceBase } from 'src/shared/services/cv-api-service-base';
import { CvConfigurationService } from './cv-configuration.service';
import { SharedServiceHelperService } from './shared-service-helper.service';

@Injectable({
    providedIn: 'root'
})
export class CVApiService extends CvApiServiceBase {
    constructor(
        sshs: SharedServiceHelperService,
        config: CvConfigurationService,
    ) {
        super(sshs.getSharedServicesEnabled(), config);
    }
}
